import React from 'react';
import NewReport from "./NewReport";
import {NewReportProvider} from "./NewReportContext";
import {useHistory} from "react-router-dom";
import {RouteLeavingGuard} from "../common";
import StorageService from 'infrastructure/common/storage';
import { Constant } from './common/data';

const queryString = require("query-string");

export const NewReportContainer = () => {
  const history = useHistory();

   //capture referal_code from uri  
   const query = queryString.parse(document.location.search);
   if (query?.referral) {
       StorageService.setItem(Constant.ls_referral_code, query.referral)
   }
   //end

  return (
    <div className="h-full p-0 lg:p-6 overflow">
      <NewReportProvider>
        {
          (state) =>
            <>
              <RouteLeavingGuard
                when={state.isDirty}
                navigate={path => history.push(path)}
                shouldBlockNavigation={location => true}
              />

              <NewReport/>
            </>
        }
      </NewReportProvider>
    </div>
  );
};

NewReportContainer.propTypes = {}

NewReportContainer.defaultProps = {}

export default NewReportContainer;
